export default [
    {
        path: '/history/:id?',
        name: 'historyRelance',
        component: () => import('@/views/history/HistoryRelance.vue'),
        meta: {
            requiresAuth: true,
            requiresAdminOrSuperAdmin: true,
            pageTitle: 'Relances de Mail',
            breadcrumb: [
              {
                text: 'Historique',
                active: true,
              },
            ],        
        },
      },
    
]